import {ChangeDetectionStrategy, Component, signal} from '@angular/core';
import {PageTitleComponent} from "../../../components/page-title/page-title.component";
import {CustomFormComponent} from "../../../components/custom-form/custom-form.component";
import {TextInputComponent} from "../../../components/text-input/text-input.component";
import {FormBuilder, Validators} from "@angular/forms";
import {AuthService} from "../../../services/auth/auth.service";
import {catchError, from, of, switchMap, throwError} from "rxjs";
import {Message} from "primeng/message";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'homey-forgot-password-page',
  imports: [
    PageTitleComponent,
    CustomFormComponent,
    TextInputComponent,
    Message
  ],
  templateUrl: './forgot-password-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordPageComponent {
  constructor(
    private readonly fb: FormBuilder,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
  ) {
  }

  protected readonly error = signal<string | undefined>(undefined);

  protected readonly form = this.fb.group({
    email: this.fb.nonNullable.control('', [Validators.required, Validators.email])
  });

  submit = () => from(this.authService.homeyForgotPassword(this.form.getRawValue().email)).pipe(
    switchMap(() => {
      this.error.set(undefined);
      // Replaced, so once the reset is done Back leaves the whole flow; the reset page's backRoute
      // still leads here to fix a mistyped email.
      return this.router.navigate(['../reset-password'], {
        relativeTo: this.activatedRoute,
        replaceUrl: true,
        queryParams: {email: this.form.getRawValue().email}
      });
    }),
    catchError((error) => {
      if ("name" in error) {
        if (error.name === "UserNotFoundException") {
          console.warn('UserNotFoundException during login', error);
          this.error.set("A user with the given email does not exist. Did you sign in with Google/Apple or did you enter your email incorrectly?");
          return of(undefined);
        }
        if (error.name === "NotAuthorizedException") {
          this.error.set("Invalid password");
          return of(undefined);
        }
      } else if ("message" in error && typeof error.message === 'string') {
        if (error.message.contains("UserNotFoundException")) {
          this.error.set("A user with the given email does not exist. Did you sign in with Google/Apple or did you enter your email incorrectly?");
          return of(undefined);
        }
        if (error.message.contains("NotAuthorizedException")) {
          this.error.set("Invalid password");
          return of(undefined);
        }
      }
      this.error.set(undefined);
      return throwError(() => error);
    })
  );
}
